export const PRONOUNS = {
    'He/him': {
        en: 'He/him',
        es: 'Él'
    },
    'She/her': {
        en: 'She/her',
        es: 'Ella'
    },
    'They/them': {
        en: 'They/them',
        es: 'Elle'
    },
    dna: {
        en: 'Prefer Not to Answer',
        es: 'Prefiero no responder'
    }
} as Record<string, { en: string; es: string }>;
